import { loadAllRemainingPages, hasMorePages } from "./infiniteScroll";
import { matchesTag, setActiveTag, getActiveTag } from "./tagUtils";
import initMahjongRenderer from "./mahjong";
import initCodeHighlighting from "./codeHighlight";

export default function initTagFilter() {
    const tagSection = document.querySelector(".gh-tagcloud-section");
    if (!tagSection) return;

    const tagItems = tagSection.querySelectorAll(".gh-tagcloud-item");
    const feed = document.getElementById("gh-postfeed") || document.querySelector(".gh-postfeed");
    const emptyNotice = document.getElementById("gh-filter-empty");

    if (!tagItems.length || !feed) return;

    function applyFilter(selectedTag) {
        setActiveTag(selectedTag);
        const cards = feed.querySelectorAll(".gh-card, .post");
        let visibleCount = 0;

        cards.forEach((card) => {
            if (matchesTag(card, selectedTag)) {
                card.style.display = "";
                visibleCount++;
            } else {
                card.style.display = "none";
            }
        });

        if (emptyNotice) {
            emptyNotice.style.display = visibleCount === 0 ? "block" : "none";
        }
    }

    async function handleTagSelect(item, tag) {
        tagItems.forEach((b) => {
            b.classList.remove("is-active");
            b.setAttribute("aria-selected", "false");
        });

        item.classList.add("is-active");
        item.setAttribute("aria-selected", "true");

        applyFilter(tag);

        // If a specific tag filter is activated and there are more pages, fetch all remaining posts
        if (tag !== "all" && hasMorePages()) {
            tagSection.classList.add("is-loading");
            await loadAllRemainingPages((newPosts) => {
                const currentTag = getActiveTag();
                newPosts.forEach((post) => {
                    if (matchesTag(post, currentTag)) {
                        post.style.display = "";
                    } else {
                        post.style.display = "none";
                    }
                });
                if (typeof initMahjongRenderer === "function") initMahjongRenderer();
                if (typeof initCodeHighlighting === "function") initCodeHighlighting();
                applyFilter(currentTag);
            });
            tagSection.classList.remove("is-loading");
            applyFilter(getActiveTag());
        }
    }

    tagItems.forEach((btn) => {
        btn.addEventListener("click", (e) => {
            // Prevent navigating away if it's an anchor tag
            if (btn.tagName.toLowerCase() === "a") {
                e.preventDefault();
            }
            const tag = btn.getAttribute("data-tag") || "all";
            handleTagSelect(btn, tag);
        });
    });

    // Support URL hash or query param if user lands with ?tag=xxx or #tag-xxx
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const tagParam = urlParams.get("tag");
        if (tagParam) {
            const matchBtn = Array.from(tagItems).find((b) => b.getAttribute("data-tag") === tagParam);
            if (matchBtn) {
                handleTagSelect(matchBtn, tagParam);
            }
        }
    } catch (e) {
        // Ignore URL parsing errors
    }
}
